import React from "react";
import { Thead, Th, CheckboxCell } from "./Table.style";
import { resolveColumnPresentation } from "./columnPresentation";

/**
 * TableHeader – renders column headers with optional sort indicators and select-all.
 */
export default function TableHeader({
  columns = [],
  sorting,
  stickyHeader,
  showSelection,
  showActions,
  rowSelection,
  data = [],
  rowKey = "id",
}) {
  const handleSort = (key) => {
    if (sorting?.onSort) sorting.onSort(key);
  };

  const allKeys = data.map((row, i) =>
    typeof rowKey === "function" ? rowKey(row) : row[rowKey] ?? row.id ?? String(i)
  );
  const selectedSet = new Set(rowSelection?.selectedRowKeys ?? []);
  const allSelected = allKeys.length > 0 && allKeys.every((k) => selectedSet.has(k));
  const someSelected = allKeys.some((k) => selectedSet.has(k));

  const handleSelectAll = (e) => {
    if (!rowSelection?.onChange) return;
    rowSelection.onChange(e.target.checked ? [...allKeys] : []);
  };

  return (
    <Thead $sticky={stickyHeader}>
      <tr>
        {showSelection && (
          <CheckboxCell as="th" style={{ width: 40 }}>
            <input
              type="checkbox"
              checked={allSelected}
              ref={(el) => el && (el.indeterminate = someSelected && !allSelected)}
              onChange={handleSelectAll}
              aria-label="Select all rows"
            />
          </CheckboxCell>
        )}
        {columns.map((col) => {
          const { headerAlign, width } = resolveColumnPresentation(col);
          return (
            <Th
              key={col.key}
              $align={headerAlign}
              $width={width}
              $sortable={col.sortable && !!sorting?.onSort}
              onClick={() => col.sortable && handleSort(col.key)}
            >
              {typeof col.headerRender === "function" ? col.headerRender() : col.label ?? col.key}
              {sorting && sorting.sortKey === col.key && (
                <span style={{ marginLeft: 4 }}>{sorting.direction === "asc" ? " ↑" : " ↓"}</span>
              )}
            </Th>
          );
        })}
        {showActions && <Th style={{ width: 120, textAlign: "right" }}>Actions</Th>}
      </tr>
    </Thead>
  );
}
